<template>
  <div class="s-c-upload">
    <Upload action="qnurl" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload"
      :http-request="uploadattached" :accept="accept" :on-remove="handleRemove" :before-remove="beforeRemove">
      <!-- <div class="upload-btn">{{btnText}}</div> -->
      <slot />
    </Upload>
  </div>
</template>

<script>
  import {
    Upload
  } from 'element-ui';
  // import config from '@/config/index';

  import {
    uploadtoken,
    upload,
  } from '@/api/file.js'

  export default {
    props: ["btnText","accept"],
    data() {
      return {
        qnurl: 'http://upload.qiniup.com/',
        attachment: []
      }
    },
    components: {
      Upload
    },
    methods: {
      handleSuccess(res, file) {
        this.realImgUrl = URL.createObjectURL(file.raw);
      },
      beforeUpload(file) {
        const isJPG = true
        if(!this.accept){
          const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
          if (!isJPG) {
            this.$message.error('上传文件只能是 JPG或PNG 格式!');
          }
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      uploadattached: function(request) {
        this.upLoader(request)
      },
      upLoader(request) {
        console.log("call uploader..")
        this.fname = request.file.uid + request.file.name;
        console.log(this.fname);
        var that = this;
        uploadtoken({
          "filename": this.fname
        }).then(res => {
          let token = res.data;
          console.log("七牛token----",token)
          console.log("请求" + JSON.stringify(request))
          upload(
            this.fname,
            token,
            request,
            next => {
              let total = next.total;
              console.log(total);
            },
            error => {
              console.log(error)
            },
            complete => {
              let hash = complete.hash;
              let key = complete.key;
              console.log("emit fname");
              console.log(this.fname);
              // this.realImgUrl = `${config.VUE_APP_IMG_HOST }${this.fname}`;
              that.$emit('resetImageName', this.fname)
            }
          )
        });
      },
      handleRemove(files, fileList) {
        this.attachment = fileList;
        console.log(this.attachment);
        this.$emit('resetAttachment', '')
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
    }
  }
</script>

<style scoped>
  .s-c-upload {
    width: 100%;
    height: 100%;
    /* position: relative; */
  }

  .upload-btn {
    color: #1775F0;
    font-size: 14px;
    display: inline-block;
  }
</style>
